import * as VideoConsultationsConstants from "../constants/VideoConsultations";

const initialState = {
  isCountsLoading: false,
  counts: {
    cancelled_count: 0,
    scheduled_count: 0,
    running_count: 0,
    completed_count: 0
  }
};

export function videoConsultations(state = initialState, action) {
  switch (action.type) {
    case VideoConsultationsConstants.FETCH_VIDEO_CONSULTATIONS_COUNT_STARTED:
      return Object.assign({}, state, {
        isCountsLoading: true
      });
    case VideoConsultationsConstants.FETCH_VIDEO_CONSULTATIONS_COUNT_COMPLETED:
      return Object.assign({}, state, {
        isCountsLoading: false,
        counts: action.counts.attributes
      });
    default:
      return state;
  }
}
